import { DateObjects } from '../orders/types';
import { Meal } from '../meals/types';
export const SET_USERS = 'SET_USERS';
export const GET_USERS = 'GET_USERS';
export const GET_USERS_ORDERS = 'GET_USERS_ORDERS';
export const SET_USERS_ORDERS = 'SET_USERS_ORDERS';
export const DELETE_PHOTO = 'DELETE_PHOTO';
export const SET_COOKMEALS = 'SET_COOKMEALS';
export const GET_COOKMEALS = 'GET_COOKMEALS';
export const GET_ADVERTISEMENT = 'GET_ADVERTISEMENT';
export const SET_ADVERTISEMENT = 'SET_ADVERTISEMENT';
export const ADD_ADVERTISEMENT = 'ADD_ADVERTISEMENT';
export const DELETE_ADS = 'DELETE_ADS';

export interface FirestoreSnapshot {
  id: string;
  data: Function;
}

export interface UserState {
  name: string;
  phone: string;
  accountType: string;
  status: string;
}

export interface OrderState {
  id: string;
  title: string;
  description: string;
  status: string;
  consumptiondate: DateObjects;
}

export interface AdsState {
  id: string;
  name: string;
  siteUrl: string;
  image: string;
  position: string;
}

export interface AdminProps {
  users: Array<UserState>;
  orders: Array<OrderState>;
  meals: Array<Meal>;
  advertisement: Array<AdsState>;
}

export interface SetUsersAction extends AdminProps {
  type: typeof SET_USERS;
  users: Array<UserState>;
}

export interface GetUsersAction extends AdminProps {
  type: typeof GET_USERS;
}

export interface GetOrderAction extends AdminProps {
  type: typeof GET_USERS_ORDERS;
  key: string;
  accountType: string;
}

export interface SetOrderAction extends AdminProps {
  type: typeof SET_USERS_ORDERS;
  orders: Array<OrderState>;
}

export interface DeletePhotoAction extends AdminProps {
  type: typeof DELETE_PHOTO;
  key: string;
  deletetype: string;
}

export interface SetCookMealsAction extends AdminProps {
  type: typeof SET_COOKMEALS;
  meals: Array<Meal>;
}

export interface GetCookMealsAction extends AdminProps {
  type: typeof GET_COOKMEALS;
  cookid?: string;
}

// export interface UploadAds extends AdminProps {
//   type: typeof ADD_ADVERTISEMENT;
//   image: string;
//   name: string;
// }

export interface UploadAds extends AdminProps {
  type: typeof ADD_ADVERTISEMENT;
  banner: AdsState;
}

export interface DeleteAdsAction extends AdminProps {
  type: typeof DELETE_ADS;
  id: string;
}

export interface SetAds extends AdminProps {
  type: typeof SET_ADVERTISEMENT;
  advertisement: Array<AdsState>;
}

export interface GetAdsAction extends AdminProps {
  type: typeof GET_ADVERTISEMENT;
}

export type AdminActionTypes =
  | SetUsersAction
  | GetUsersAction
  | GetOrderAction
  | SetOrderAction
  | SetCookMealsAction
  | GetCookMealsAction
  | DeletePhotoAction
  | UploadAds
  | GetAdsAction
  | DeleteAdsAction
  | SetAds;
